//
//
//
//
//
//
//
//
//
//

import HeroSection from '@/components/PagsmileCard/components/HeroSection.vue'
import PagsmileCard from '@/components/PagsmileCard/components/PagsmileCard.vue'
import HowItWorks from '@/components/PagsmileCard/components/HowItWorks.vue'
import UseCases from '@/components/PagsmileCard/components/UseCases.vue'
import StartNow from '@/components/PagsmileCard/components/StartNow.vue'

const lg = '(min-width: 1024px)'
const md = '(max-width: 1023.99px) and (min-width: 501px)'
const sm = '(max-width: 500.99px)'

export default {
  components: {
    HeroSection, PagsmileCard, HowItWorks, UseCases, StartNow
  },
  data () {
    return {
      interval: null,
      windowWidth: typeof window !== 'undefined' ? window.innerWidth : null,
      isPC:
        typeof window !== 'undefined' ? window.matchMedia(lg).matches : false,
      isTablet:
        typeof window !== 'undefined' ? window.matchMedia(md).matches : false,
      isMobile:
        typeof window !== 'undefined' ? window.matchMedia(sm).matches : false
    }
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeDestroy () {
    clearTimeout(this.interval)
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    onResize () {
      clearTimeout(this.interval)
      this.interval = setTimeout(() => {
        this.windowWidth = window.innerWidth
        this.isPC = window.matchMedia(lg).matches
        this.isTablet = window.matchMedia(md).matches
        this.isMobile = window.matchMedia(sm).matches
      }, 500)
    },
    visibilityChanged (isVisible, entry) {
      if (isVisible) {
        const element = entry.target
        element.classList.add('animation-pull-up-active')
      } else {
        const element = entry.target
        element.classList.remove('animation-pull-up-active')
      }
    }
  }
}
